export default __webpack_public_path__ + "static/media/dental-icon.db403812.png";